import { render, staticRenderFns } from "./MaterialStatsCard.vue?vue&type=template&id=248917aa&"
import script from "./MaterialStatsCard.vue?vue&type=script&lang=js&"
export * from "./MaterialStatsCard.vue?vue&type=script&lang=js&"
import style0 from "./MaterialStatsCard.vue?vue&type=style&index=0&id=248917aa&prod&lang=sass&"
import style1 from "./MaterialStatsCard.vue?vue&type=style&index=1&id=248917aa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports